module.exports = __webpack_public_path__ + "static/img/servicios.37a247ab.jpg";